export default __webpack_public_path__ + "static/media/greyarea.f103adfd.mp4";